import { createGlobalState } from '@vueuse/core';
import { computed, ref } from 'vue';
import axios from 'axios';
import type { MessageHubRuleRestrictions } from '~/types/messageRules.types';

export const useMessageHubRules = createGlobalState(() => {
    const teamId = Spark.state.currentTeam.id;
    const rules = ref<MessageHubRuleRestrictions | null>(null);
    const loading = ref(false);
    const lastGroupId = ref<string | null>(null);

    const getMessageHubRules = async (groupId: string | undefined) => {
        if (!groupId) {
            rules.value = null;
            lastGroupId.value = null;
            return;
        }

        if (groupId === lastGroupId.value) {
            return;
        }

        loading.value = true;
        lastGroupId.value = groupId;

        try {
            const response = await axios.get(`/api/v3/teams/${teamId}/groups/${groupId}/message-hub/rules`);
            if (lastGroupId.value === groupId) {
                rules.value = response.data.rules;
            }
        } catch {
            if (lastGroupId.value === groupId) {
                rules.value = null;
                lastGroupId.value = null;
            }
        } finally {
            if (lastGroupId.value === groupId) {
                loading.value = false;
            }
        }
    };

    const blockImages = computed(() => rules.value?.block_images ?? false);
    const blockFiles = computed(() => rules.value?.block_files ?? false);

    const reset = () => {
        rules.value = null;
        lastGroupId.value = null;
    };

    return { rules, loading, getMessageHubRules, blockImages, blockFiles, reset };
});
